<template>
	<div class="header-view-type">
		<el-button-group>
			<el-button :type="viewTypeSearch == 'show-list' ? 'primary' : 'default'" size="small" @click="$emit('change','show-list')"><i class="fas fa-list-ul"></i></el-button>
			<el-button :type="viewTypeSearch == 'show-menu' ? 'primary' : 'default'" size="small" @click="$emit('change','show-menu')"><i class="el-icon-menu"></i></el-button>
			<el-button :type="viewTypeSearch == 'show-table' ? 'primary' : 'default'" size="small" @click="$emit('change','show-table')"><i class="fas fa-table"></i></el-button>
		</el-button-group>
	</div>
</template>

<script>
	export default {
		name: 'HeaderViewType',
		props: {
			viewTypeSearch: String
		}
	}
</script>

<style lang="scss">
.el-button-group {
	display: flex;
    flex-shrink: 1;
}
</style>
